function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import React, { useCallback } from 'react';
export { createEventChannel, withFilter, createTransformer } from '@atlassian/commerce-events-core-react';
export var createEventChannelBridgeFactory = function createEventChannelBridgeFactory(eventChannelFactory, sendPayloadCallack) {
  return function () {
    var eventChannel = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : eventChannelFactory();

    var Bridge = function Bridge(_ref) {
      var client = _ref.client,
          children = _ref.children;
      return /*#__PURE__*/React.createElement(eventChannel.Listener, {
        onEvent: useCallback(function (payload) {
          sendPayloadCallack(client, payload);
          return payload;
        }, [client])
      }, children);
    };

    return {
      /**
       * @internal
       * Used by integration packages
       */
      eventChannel: eventChannel,
      Bridge: Bridge
    };
  };
};
export var withClient = function withClient(client, Component) {
  return function (_ref2) {
    var children = _ref2.children;
    return /*#__PURE__*/React.createElement(Component, {
      client: client
    }, children);
  };
};
export var combineBridges = function combineBridges() {
  for (var _len = arguments.length, bridges = new Array(_len), _key = 0; _key < _len; _key++) {
    bridges[_key] = arguments[_key];
  }

  var CombinedSendEvents = function CombinedSendEvents(_ref3) {
    var children = _ref3.children,
        client = _ref3.client;
    var wrappedChildren = children;

    var _iterator = _createForOfIteratorHelper(bridges),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _SendEventsComponent = _step.value;
        wrappedChildren = _SendEventsComponent({
          client: client,
          children: wrappedChildren
        });
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    return /*#__PURE__*/React.createElement(React.Fragment, null, wrappedChildren);
  };

  return CombinedSendEvents;
}; // TODO: Better types

export var renderCombined = function renderCombined(children, components) {
  var wrappedChildren = children;

  var _iterator2 = _createForOfIteratorHelper(components),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var Component = _step2.value;
      wrappedChildren = /*#__PURE__*/React.createElement(Component, null, wrappedChildren);
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  return wrappedChildren;
};